<template>
  <div class="introduce-scroll">
    <div class="introduce-container">
      <img class="logo" src="@/assets/introduce/logo.png" alt="">
      <div class="banner-container">
        <img class="banner" src="@/assets/introduce/banner.png" alt="" />
        <div class="introduce-flow">
          <div class="title">
            <img class="left" src="@/assets/introduce/icon.png" alt="">
            推荐流程
            <img class="right" src="@/assets/introduce/icon.png" alt="">
          </div>
          <div class="flow-list">
            <div class="flow-item">
              <div class="flow-index">1</div>
              <div class="flow-name">提交朋友信息</div>
            </div>
            <div class="flow-item">
              <div class="flow-index">2</div>
              <div class="flow-name">朋友签约</div>
            </div>
            <div class="flow-item">
              <div class="flow-index">3</div>
              <div class="flow-name">给您发放奖励</div>
            </div>
          </div>
        </div>
      </div>
      <div class="introduce-form">
        <div class="title">您推荐的客户信息</div>
        <div :class="{'form-item': true, 'error': errorVerification.company}">
          <input type="text" v-model="inviteForm.company" placeholder="朋友的企业名称" maxlength="30" @blur="formChange('company')">
          <span v-if="errorVerification.company" class="error">请填写朋友的企业名称</span>
        </div>
        <div :class="{'form-item': true, 'error': errorVerification.username}">
          <input type="text" v-model="inviteForm.username" placeholder="朋友的姓名" maxlength="30" @blur="formChange('username')">
          <span v-if="errorVerification.username" class="error">请填写朋友的姓名</span>
        </div>
        <div :class="{'form-item': true, 'error': errorVerification.invite_phone}">
          <input type="text" v-model="inviteForm.invite_phone" placeholder="朋友的手机号" maxlength="11" @blur="formChange('invite_phone')">
          <span v-if="errorVerification.invite_phone" class="error">
            {{inviteForm.invite_phone ? (inviteForm.invite_phone === inviteForm.referrer_phone ? '不可以推荐自己' : '手机号不正确') : '请填写朋友的手机号'}}
          </span>
        </div>
        <div :class="{'form-item': true, 'error': errorVerification.referrer_phone}">
          <input type="text" v-model="inviteForm.referrer_phone" placeholder="您的手机号（便于领奖）" maxlength="11" @blur="formChange('referrer_phone')">
          <span v-if="errorVerification.referrer_phone" class="error">
            {{inviteForm.referrer_phone ? '手机号不正确' : '请填写您的手机号'}}
          </span>
        </div>
        <div class="btn" @click="onsubmit">
          {{submitLoading ? '提交中...' : '提交'}}
        </div>
      </div>
      <div class="introduce-explain">
        <div class="title">活动说明</div>
        <div class="introduce-date">活动时间：2024年全年有效</div>
        <div class="explain-list">
          <div class="explain-item">
            <div>1.</div>
            <div class="content">推荐新客户购买360亿方云，推荐人可获得新客户<span>首购10%的奖励</span></div>
          </div>
          <div class="explain-item">
            <div>2.</div>
            <div class="content">单笔奖励金额最高可获<span>20000元</span></div>
          </div>
          <div class="explain-item">
            <div>3.</div>
            <div class="content">奖励金额以京东卡的形式发放</div>
          </div>
          <div class="explain-item">
            <div>4.</div>
            <div class="content">新客户付款后，在30日之内发放奖励</div>
          </div>
        </div>
      </div>
      <img class="coin coin1" src="@/assets/introduce/coin.png" alt="">
      <img class="coin coin2" src="@/assets/introduce/coin.png" alt="">
      <img class="coin coin3" src="@/assets/introduce/coin.png" alt="">
    </div>
    <van-dialog
      v-model="show"
      confirm-button-text="好的"
      class="introduce-dialog"
    >
      <div >
        <div class="icon">
          <img src="@/assets/introduce/success.png" alt="">
        </div>
        <div class="title">提交成功！</div>
        <div class="info">感谢您的推荐，我们将在48小时内给您反馈</div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import {MOBILE_INVITE} from '@/config/api'
import {pageShare} from '@/utils/common'
import { Toast } from 'vant'
import config from '@/config'
export default {
  name: 'Introduce',
  data () {
    return {
      show: false,
      inviteForm: {
        invite_phone: '', // 被推荐人手机号
        username: '', // 被推荐人名称
        company: '', // 企业名称
        referrer_phone: '' // 推荐人手机号
      },
      errorVerification: {},
      submitLoading: false
    }
  },
  created () {
    document.title = '最高得20000元！人人都是推荐官！'
    this.setFontSize()
  },
  mounted () {
    this.initShare()
  },
  methods: {
    setFontSize () {
      let width = document.documentElement.clientWidth
      document.documentElement.style.fontSize = 100 * (width / 430) + 'px'
    },
    formChange (key) {
      const regex = /^1[3-9]\d{9}$/
      let isVerification = false
      switch (key) {
        case 'company':
          isVerification = !this.inviteForm.company
          break

        case 'username':
          isVerification = !this.inviteForm.username
          break

        case 'invite_phone':
          isVerification = !regex.test(this.inviteForm.invite_phone) || this.inviteForm.referrer_phone === this.inviteForm.invite_phone
          break

        case 'referrer_phone':
          isVerification = !regex.test(this.inviteForm.referrer_phone)
          break

        default:
          break
      }
      if (isVerification) {
        this.$set(this.errorVerification, key, true)
      } else {
        this.$set(this.errorVerification, key, false)
      }
      console.log(this.errorVerification)
    },
    onsubmit () {
      if (this.submitLoading) return false
      this.submitLoading = true
      for (let key in this.inviteForm) {
        this.formChange(key)
      }
      let isError = false

      Object.keys(this.errorVerification).forEach((key) => {
        if (this.errorVerification[key]) {
          isError = true
        }
      })
      if (isError) {
        this.submitLoading = false
        return false
      }
      ajax({
        url: MOBILE_INVITE,
        data: this.inviteForm
      }).then(res => {
        this.submitLoading = false
        if (res && res.success) {
          this.inviteForm = {
            invite_phone: '', // 被推荐人手机号
            username: '', // 被推荐人名称
            company: '', // 企业名称
            referrer_phone: '' // 推荐人手机号
          }
          this.show = true
          this.errorVerification = {}
        } else {
          var errs = res.errors[0]
          Toast.fail(errs.error_tr_msg)
        }
      })
    },
    initShare () {
      const {imageUrl} = config
      pageShare.ready && pageShare.ready((pageShare) => {
        pageShare.shareAll({
          title: '最高得20000元！人人都是推荐官！',
          link: window.location.href,
          imgUrl: `${imageUrl}/assets/app/mobile/images/introduce-share.png`,
          desc: '360亿方云邀请你参与推荐奖励计划'
        })
      })
    }
  }
}
</script>
<style lang="postcss" scoped>
.introduce-scroll{
  height: 100%;
  overflow: auto;
  font-size: 0;
}
.introduce-container {
  overflow: hidden;
  padding-bottom: 0.35rem;
  background: linear-gradient(
    180deg,
    #dfebfc 0%,
    #427cdc 34.18%,
    #3f6cd5 60.8%,
    #3c5bce 93.55%
  );
  position: relative;
  & .logo {
    width: 0.91rem;
    position: absolute;
    top: 0.16rem;
    left: 0.16rem;
    z-index: 2;
  }
  & .coin {
    width: 0.8rem;
    position: absolute;
    z-index: 0;
    &.coin1 {
      right: -0.3rem;
      top: 5.75rem;
    }
    &.coin2 {
      left: -0.2rem;
      top: 10rem;
      transform: rotateY(180deg);
    }
    &.coin3 {
      right: 0.6rem;
      bottom: -0.3rem;
    }
  }
  & .banner-container {
    position: relative;
    z-index: 2;
    padding: 0 0.24rem;
    padding-top: 3.86rem;
    & .banner {
      width: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
    }
    & .introduce-flow {
      width: 100%;
      border-radius: 0.24rem;
      background: linear-gradient(180deg, #cfd9ff 0%, #fff 23.04%);
      box-shadow: 0px 0.08rem 0.12rem 0px rgba(0, 0, 0, 0.35);
      padding: 0.56rem 0.3rem 0.3rem 0.3rem;
      box-sizing: border-box;
      & .title {
        font-size: 0.2rem;
        font-weight: 600;
        color: #1a65ff;
        text-align: center;
        margin-bottom: 0.24rem;
        display: flex;
        align-items: center;
        justify-content: center;
        & img {
          width: 0.42rem;
          margin-left: 0.16rem;
          &.left{
            transform: rotate(180deg);
            margin-right: 0.16rem;
          }
        }
      }
      & .flow-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        & .flow-item {
          flex: 1;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          & .flow-index {
            position: relative;
            width: 0.36rem;
            height: 0.36rem;
            border-radius: 50%;
            font-size: 0.2rem;
            color: #fff;
            font-weight: 600;
            display: flex;
            justify-content: center;
            align-items: center;
            background: linear-gradient(180deg, #ffefdd 0%, #ffb048 100%);
            box-shadow: 0px 0.02rem 1px 0px rgba(188, 72, 24, 0.7);
          }
          & .flow-name {
            font-size: 0.15rem;
            line-height: 0.24rem;
            margin-top: 0.12rem;
          }
          &:nth-of-type(2) {
            & .flow-index {
              &::after {
                content: "";
                position: absolute;
                left: 0.4rem;
                top: 50%;
                width: 0.65rem;
                height: 1px;
                border-top: 1px dashed #e59a7b;
              }
              &::before {
                content: "";
                position: absolute;
                right: 0.4rem;
                top: 50%;
                width: 0.65rem;
                height: 1px;
                border-top: 1px dashed #e59a7b;
              }
            }
          }
        }
      }
    }
  }
  & .introduce-form, & .introduce-explain {
    margin: 0.4rem 0.24rem 0 0.24rem;
    padding: 0.48rem 0.24rem 0.32rem 0.24rem;
    box-sizing: border-box;
    border-radius: 0.24rem;
    background: linear-gradient(180deg, #CFD9FF 0%, #FFF 9.75%);
    box-shadow: 0px 0.08rem 0.12rem 0px rgba(0, 0, 0, 0.35);
    position: relative;
    z-index: 2;
    & .title {
      width: 100%;
      height: 0.38rem;
      line-height: 0.38rem;
      font-size: 0.20rem;
      color: #fff;
      font-weight: 600;
      text-align: center;
      background-image: url('../../assets/introduce/tag.png');
      background-position: center center;
      background-size: auto 100%;
      background-repeat: no-repeat;
      position: absolute;
      top: -0.16rem;
      left: 0;
    }
    & .form-item {
      margin-bottom: 0.20rem;
      position: relative;
      & input {
        width: 100%;
        height: 0.48rem;
        line-height: 0.48rem;
        padding: 0 0.20rem;
        border-radius: 0.28rem;
        background-color: #F7F9FA;
        font-size: 0.16rem;
        border: none;
        box-sizing: border-box;
      }
      & .error {
        font-size: 0.13rem;
        line-height: 0.48rem;
        color: #F53F3F;
        position: absolute;
        top: 0;
        right: 0.20rem;
      }
      &.error {
        & input {
          background-color: #FFECE8;
        }
      }
    }
    & .btn {
      width: 100%;
      height: 0.48rem;
      line-height: 0.48rem;
      font-size: 0.18rem;
      font-weight: 500;
      text-align: center;
      color: #fff;
      border-radius: 0.24rem;
      background: linear-gradient(248deg, #00A3FF 7.15%, #4070D7 82.2%);
    }
    & .introduce-date {
      color: #1A65FF;
      font-size: 0.16rem;
      font-weight: 600;
      line-height: 0.24rem;
    }
    & .explain-list {
      & .explain-item {
        font-size: 0.16rem;
        line-height: 0.24rem;
        display: flex;
        align-items: baseline;
        margin-top: 0.16rem;
        & .content {
          margin-left: 0.05rem;
          & span {
            font-weight: 600;
            color: #FF7D00;
          }
        }
      }
    }
  }
}
.introduce-dialog {
  width: 3.5rem;
  border-radius: 0.08rem;
  .van-dialog__content {
    padding: 0.3rem;
  }
  & .van-dialog__content {
    padding: 0.3rem;
  }
  .van-button {
    font-size: 0.16rem;
    height: 0.42rem;
    line-height: 0.40rem;
  }
  & .van-button {
    font-size: 0.16rem;
    height: 0.42rem;
    line-height: 0.40rem;
  }
  & .icon {
    font-size: 0;
    & img {
      width: 0.64rem;
    }
  }
  & .title {
    font-size: 0.2rem;
    font-weight: 600;
    margin-top: 0.2rem;
  }
  & .info {
    color: #9BA7BA;
    font-size: 0.14rem;
    margin-top: 0.08rem;
  }
}

</style>
